import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withFetch } from '@flowio/redux-fetch';
import { type RouterState } from 'react-router';
import { type UsersGetByIdResponse } from '@flowio/api-sdk';

import { type RootState, type ThunkDispatcher } from '../../../../../stores/types';
import { fetchLabByKey, putLabSettingsByKey, fetchAcceptingUser } from '../../../actions';
import labKeys from '../../../constants/lab-keys';
import { getAcceptingUser, getLabProjectErrors, getCurrentLabProjectSettings } from '../../../selectors';
import { type DispatchProps, type StateProps } from '../types';
import PayLaterLab from '../components/PayLaterLab';

const fetchAsyncState = (
  dispatch: ThunkDispatcher,
  getState: () => RootState,
  ownProps: RouterState,
): Promise<void | UsersGetByIdResponse> => {
  const { organization } = ownProps.params;

  return dispatch(fetchLabByKey(organization, labKeys.PAY_LATER)).then(() => {
    const state = getState();
    const labProjectSettings = getCurrentLabProjectSettings(state);
    if (labProjectSettings && labProjectSettings.terms) {
      return Promise.resolve(dispatch(fetchAcceptingUser(labProjectSettings.terms.accepted_by.id)));
    }
    return undefined;
  });
};

const mapStateToProps = (state: RootState): StateProps => ({
  acceptingUser: getAcceptingUser(state),
  labProjectSettings: getCurrentLabProjectSettings(state),
  error: getLabProjectErrors(state),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatcher,
  ownProps: RouterState,
): DispatchProps => ({
  onAcceptLab: () => {
    const { organization } = ownProps.params;
    dispatch(putLabSettingsByKey(organization, labKeys.PAY_LATER, true));
  },
});

export default compose<React.FC<{}>>(
  withFetch(fetchAsyncState),
  connect<
  StateProps,
  DispatchProps,
  RouterState,
  RootState>(mapStateToProps, mapDispatchToProps),
)(PayLaterLab);
